/* ============================================================
   Irio — global.js  (vanilla, no deps, defer-loaded)
   - Accordion toggle for [data-accordion]
   - Smooth-scroll for in-page anchor links
   - Pause marquees on hover (progressive enhancement)
   Cart / variant handling is left to Shopify's product form.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Accordion ---------- */
  function initAccordions() {
    var groups = document.querySelectorAll("[data-accordion]");
    if (!groups.length) return;

    groups.forEach(function (group) {
      var trigger = group.querySelector("[data-accordion-trigger]");
      if (!trigger) return;

      // Make keyboard-accessible if not a native button.
      if (trigger.tagName !== "BUTTON") {
        trigger.setAttribute("role", "button");
        if (!trigger.hasAttribute("tabindex")) trigger.setAttribute("tabindex", "0");
      }

      var setState = function (open) {
        group.classList.toggle("is-open", open);
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
      };

      setState(group.classList.contains("is-open"));

      var toggle = function (e) {
        e.preventDefault();
        setState(!group.classList.contains("is-open"));
      };

      trigger.addEventListener("click", toggle);
      trigger.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          toggle(e);
        }
      });
    });
  }

  /* ---------- Smooth-scroll for in-page anchors ---------- */
  function initSmoothScroll() {
    var prefersReduced = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;

      var hash = link.getAttribute("href");
      if (!hash || hash === "#" || hash.length < 2) return;

      var target;
      try {
        target = document.querySelector(hash);
      } catch (err) {
        return; // invalid selector, let browser handle it
      }
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({
        behavior: prefersReduced ? "auto" : "smooth",
        block: "start"
      });

      if (history && history.pushState) {
        history.pushState(null, "", hash);
      }
    });
  }

  /* ---------- Pause marquees on hover ---------- */
  function initMarquees() {
    var marquees = document.querySelectorAll(".irio-marquee");
    if (!marquees.length) return;

    marquees.forEach(function (m) {
      m.addEventListener("mouseenter", function () {
        m.style.animationPlayState = "paused";
      });
      m.addEventListener("mouseleave", function () {
        m.style.animationPlayState = "running";
      });
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    initAccordions();
    initSmoothScroll();
    initMarquees();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init accordions/marquees when sections are re-rendered in the theme editor.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      initAccordions();
      initMarquees();
    });
  }
})();
